import React from 'react'
import moment from 'moment'

export const displayValue = value => {
  if(value === null || value === undefined || value === '') return '—'
  return typeof value === 'object' ? JSON.stringify(value) : String(value)
}

export const formatDate = value => {
  if(typeof value !== 'number' || !Number.isFinite(value)) return '—'
  const date = moment(value)
  return date.isValid() ? date.format('DD/MM/YYYY HH:mm:ss') : '—'
}

export const statusLabel = value => displayValue(value).replace(/_/g, ' ')

export const Status = ({value}) => {
  const color = {
    delivered: 'success', accepted: 'primary', failed: 'danger',
    permanent_failure: 'danger', temporary_failure: 'warning', pending: 'warning',
  }[value] || 'secondary'
  return <span className={`badge badge-light-${color}`}>{statusLabel(value)}</span>
}

export const DeliveryCounts = ({counts}) => (
  <div className='d-flex flex-wrap gap-2'>
    {['pending', 'accepted', 'temporary_failure', 'delivered', 'permanent_failure'].map(status => (
      <span key={status} className='text-nowrap'>
        <Status value={status} /> {counts?.[status] ?? '—'}
      </span>
    ))}
  </div>
)

export const RequestError = ({error, retry}) => {
  if(!error) return null
  const denied = /permission-denied|unauthenticated/.test(error.code || '')
  const needsIndex = /failed-precondition/.test(error.code || '') && /index/i.test(error.message || '')
  return (
    <div className='alert alert-danger d-flex align-items-center justify-content-between gap-3' role='alert'>
      <span>{denied
        ? 'Access denied. Sign in with a production administrator account to view email tracking.'
        : needsIndex
          ? 'The database index for these filters is not ready. Deploy the email sending indexes and wait for them to finish building, then retry.'
          : 'Unable to load email tracking. Please try again.'}</span>
      <button type='button' className='btn btn-sm btn-light' onClick={retry}>Retry</button>
    </div>
  )
}

export const Pagination = ({pager, label}) => (
  <nav aria-label={`${label} pagination`} className='d-flex align-items-center justify-content-end gap-3 mt-5'>
    <button type='button' className='btn btn-sm btn-light' disabled={pager.loading || pager.pageIndex === 0}
      onClick={() => pager.goTo(pager.pageIndex - 1)}>Previous</button>
    <span aria-live='polite'>Page {pager.pageIndex + 1}</span>
    <button type='button' className='btn btn-sm btn-light' disabled={pager.loading || !pager.page?.hasNext}
      onClick={() => pager.goTo(pager.pageIndex + 1)}>Next</button>
  </nav>
)

export const Loading = () => <div role='status' className='py-4'>Loading email tracking…</div>
